import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Home from './pages/Home';
import Register from './pages/Register';
import ApplySchool from './pages/ApplySchool';
import Dashboard from './pages/Dashboard';import ParentDashboard from './pages/ParentDashboard';import StudentDashboard from './pages/StudentDashboard';import StudentGrades from './pages/StudentGrades';import StudentAttendance from './pages/StudentAttendance';import StudentTimetable from './pages/StudentTimetable';import StudentMessages from './pages/StudentMessages';import TeacherDashboard from './pages/TeacherDashboard';import Messages from './pages/Messages';import Timetable from './pages/Timetable';
import Students from './pages/Students';
import Teachers from './pages/Teachers';
import Courses from './pages/Courses';
import Attendance from './pages/Attendance';
import Grades from './pages/Grades';
import AdminDashboard from './pages/AdminDashboard';
import CourseBuilder from './pages/CourseBuilder';
import LearningView from './pages/LearningView';
import Assessments from './pages/Assessments';
import Surveys from './pages/Surveys';
import ProgressReport from './pages/ProgressReport';
import SuperAdmin from './pages/SuperAdmin';
import SchoolApplications from './pages/SchoolApplications';import StudentLoginReport from './pages/StudentLoginReport';import AccountSecurity from './pages/AccountSecurity';import AccountProfile from './pages/AccountProfile';import AcademicPeriods from './pages/AcademicPeriods';import Discipline from './pages/Discipline';import StudentReports from './pages/StudentReports';
import './App.css';
import AppErrorBoundary from './components/AppErrorBoundary';

const getStoredUser = () => { try { return JSON.parse(localStorage.getItem('userInfo') || 'null'); } catch (e) { localStorage.removeItem('userInfo'); return null; } };
function RouteRecovery({ children }) { const location = useLocation(); return <AppErrorBoundary routeKey={location.pathname}>{children}</AppErrorBoundary>; }
function App() {
  const role = getStoredUser()?.role;
  const student = role === 'student'; const parent = role === 'parent';
  return (
    <Router>
      <div className="App">
        <RouteRecovery><Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/register" element={<Register />} />
          <Route path="/apply-school" element={<ApplySchool />} />
          <Route path="/dashboard" element={student?<StudentDashboard/>:parent?<ParentDashboard/>:<Dashboard/>} />
          <Route path="/teacher" element={<TeacherDashboard user={getStoredUser()} />} />
          <Route path="/messages" element={student?<StudentMessages/>:parent?<Navigate to="/dashboard" replace/>:<Messages />} />
          <Route path="/timetable" element={student?<StudentTimetable/>:parent?<Navigate to="/dashboard" replace/>:<Timetable />} />
          <Route path="/students" element={student?<Navigate to="/dashboard" replace/>:<Students />} />
          <Route path="/teachers" element={<Teachers />} />
          <Route path="/courses" element={parent?<Navigate to="/dashboard" replace/>:<Courses />} />
          <Route path="/courses/:courseId/builder" element={<CourseBuilder />} />
          <Route path="/assessments" element={<Assessments />} />
          <Route path="/surveys" element={<Surveys />} />
          <Route path="/learn/:courseId" element={<LearningView />} />
          <Route path="/courses/:courseId/report" element={<ProgressReport />} />
          <Route path="/attendance" element={student?<StudentAttendance/>:parent?<Navigate to="/dashboard" replace/>:<Attendance />} />
          <Route path="/grades" element={student?<StudentGrades/>:parent?<Navigate to="/dashboard" replace/>:<Grades />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/superadmin" element={<SuperAdmin />} />
          <Route path="/account/profile" element={<AccountProfile />} />
          <Route path="/account/security" element={<AccountSecurity />} />
          <Route path="/superadmin/applications" element={<SchoolApplications />} />
          <Route path="/academic-periods" element={<AcademicPeriods />} />
          <Route path="/discipline" element={<Discipline />} />
          <Route path="/student-reports" element={<StudentReports />} />
          <Route path="/student-login-report" element={<StudentLoginReport />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes></RouteRecovery>
      </div>
    </Router>
  );
}

export default App;
